// @flow
export { Tab, Tabs } from "./Tabs";
